import { AppState } from './../index';
import { createSelector } from '@ngrx/store';
import { conversationState, selectAllConversations, selectConversationTotalCount } from './reducers';
import { Conversation } from '@repo/shared/src/services/messaging-service/messaging-service.types';

export const selectFeature = (state: AppState) => state.conversation;

export const getConversationSelected = createSelector(
  selectFeature,
  (state: conversationState) => state.conversationSelected,
);

export const getIsloading = createSelector(selectFeature, (state: conversationState) => state.isLoading);

export const getIsloaded = createSelector(selectFeature, (state: conversationState) => state.isLoaded);

export const getIsDeleting = createSelector(selectFeature, (state: conversationState) => state.isDeleting);

export const getHasError = createSelector(selectFeature, (state: conversationState) => state.error);

export const getConversationSelectedParticipants = createSelector(getConversationSelected, conversation => {
  const participants: any[] = [];
  conversation?.participants.primary.forEach(p => {
    if (p.role !== 'client') {
      participants.push(p);
    }
  });
  conversation?.participants.secondary?.forEach(p => {
    if (p.role !== 'client') {
      participants.push(p);
    }
  });

  return participants;
});

export const getConversationList = createSelector(selectFeature, selectAllConversations);

export const getConversationTotalCount = createSelector(selectFeature, selectConversationTotalCount);

export const getUnreadConversationCount = createSelector(
  getConversationList,
  (conversations: Conversation[]) => conversations.filter(c => !c.isRead && c.status === 'IN_PROGRESS').length,
);
